sn-asks {
  // Layout styles copied from features-type-8
  .sn-asks__cards {
    display: flex;
    align-items: stretch;
    flex-direction: column;
    gap: var(--spacing-4xl);

    @include desktop {
      flex-direction: row;
    }

    > * {
      flex: 1 1 0;
      min-width: 0;
    }
  }

  me-heading {
    margin-bottom: px-to-rem(12px);
    text-align: center;

    @include above(768px) {
      margin-bottom: px-to-rem(16px);
    }

    @include above(1200px) {
      margin-bottom: px-to-rem(22px);
    }
  }

  me-text {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: px-to-rem(28px);
    text-align: center;
    font-size: px-to-rem(14px);
    line-height: px-to-rem(24px);

    @include above(768px) {
      margin-bottom: px-to-rem(34px);
      font-size: px-to-rem(16px);
      line-height: px-to-rem(28px);
    }

    @include above(960px) {
      margin-bottom: px-to-rem(38px);
      max-width: 70%;
    }

    @include above(1200px) {
      margin-bottom: px-to-rem(42px);
      font-size: px-to-rem(20px);
      line-height: px-to-rem(32px);
    }
  }

  .sn-asks__link {
    display: block;
    text-decoration: none;

    &:hover {
      text-decoration: none;

      features-card-type-6 {
        me-heading[slot='heading'] {
          color: #0777cf;
        }
      }
    }
  }

  // Override features-card-type-6 styles
  .features-card-type-6 {
    border: none;

    me-heading[slot='heading'] {
      margin-bottom: 0;
      font-size: px-to-rem(16px);
      line-height: px-to-rem(24px);
      font-weight: 700;
      color: #2c2c2c;

      @include above(768px) {
        font-size: px-to-rem(20px);
        line-height: px-to-rem(28px);
      }

      @include above(1200px) {
        font-size: px-to-rem(24px);
        line-height: px-to-rem(32px);
      }
    }

    me-text[slot='description'] {
      font-size: px-to-rem(14px);
      line-height: px-to-rem(24px);
      color: #2c2c2c;
    }
  }
}
